<template>
  <DialogFull :data="dialogSettings" hideCloseButton>
    <template v-slot:dialog.body>
      <JobInfoBar v-if="currentBooking" :title="currentBooking.title" />
      <div class="container col-md-8 col-sm-12">
        <div>
          <v-img
            :src="require('@/assets/svg/application_error_icon.svg')"
            :alt="title"
            class="mb-5"
            height="140"
            contain
          />
          <h2 class="mb-2 d-flex justify-center text-center">
            {{ title }}
          </h2>
          <span class="secondary-text d-flex justify-center text-center mb-5">
            To make an application you need to either create a candidate account
            log in to an existing candidate account.
          </span>
        </div>
        <div class="d-flex justify-center">
          <PrimaryButton @click.native="switchAccount">
            Switch Account
          </PrimaryButton>
        </div>
      </div>
    </template>
  </DialogFull>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { BOOKINGS_NAMESPACE } from "@/store/modules/bookings/actions";
import { createNamespacedHelpers } from "vuex";
import { GET_CURRENT_BOOKING } from "@/store/modules/bookings/getters";
import DialogFull from "@/components/common/DialogFull";
import JobInfoBar from "@/views/profile/components/JobInfoBar";
import { clearLocalStorageItems } from "@/services/APIService";

const { mapGetters } = createNamespacedHelpers(BOOKINGS_NAMESPACE);

export default {
  name: "SwitchAccount",
  components: {
    PrimaryButton,
    DialogFull,
    JobInfoBar
  },
  data() {
    return {
      title: "You can’t make applications with this account"
    };
  },
  computed: {
    ...mapGetters({
      currentBooking: GET_CURRENT_BOOKING
    }),
    dialogSettings() {
      return {
        dialog: true,
        title: "New Application"
      };
    }
  },
  methods: {
    switchAccount() {
      clearLocalStorageItems();
      const redirectionUrl = `${process.env.VUE_APP_AUTH_URL}/login?select=true&booking_id={booking_id}&utm_source=link`;
      window.location.href = redirectionUrl;
    }
  }
};
</script>

<style lang="scss"></style>
